import { Component } from 'react';
import ListenerMethods from 'reflux-core/lib/ListenerMethods';
import invariant from 'invariant';

function RefluxListener() {}
RefluxListener.prototype = ListenerMethods;

export default function (listenable, key, filterFunc = (x) => x) {
  return function (WrappedComponent) {
    return class Inner extends Component {
      constructor(props) {
        super(props);
        invariant(
          !Object.prototype.hasOwnProperty.call(props, key),
          `Key collision for ${key} between component and Reflux Connector`
        );
        this.state = this.getState();
        this.refluxListener = new RefluxListener();
      }

      getState() {
        if (typeof listenable.getInitialState !== 'function') {
          return {};
        }

        const result = filterFunc.call(
          this,
          listenable.getInitialState(),
          this.props
        );
        return typeof result !== 'undefined' ? { [key]: result } : {};
      }

      componentDidMount() {
        this.subscription = this.refluxListener.listenTo(
          listenable,
          (state) => {
            const result = filterFunc.call(this, state, this.props);
            this.setState({ [key]: result });
          }
        );
      }

      componentWillUnmount() {
        this.subscription.stop();
        this.refluxListener.stopListeningToAll();
      }

      render() {
        return <WrappedComponent ref {...this.props} {...this.state} />;
      }
    };
  };
}
